import {
  createDatabaseTable,
  addDatabaseItem,
  getCustomDatabaseItems,
} from '../../services/axios/data.api';

import customWidgetDatabaseSchema from '@/assets/data-schemas/customWidgetDatabaseSchema.json';
import store from '../../store/store';
export const createCustomWidgetDatabase = async () => {
  try {
    const databaseSchema = customWidgetDatabaseSchema.map((schema, index) => ({
      ...schema,
      id: Date.now() + (index + 1),
    }));
    const formData = new FormData();
    formData.append('caption', 'custom-widgets');
    formData.append('add_only', false);
    formData.append('icon', null);
    formData.append(
      'tablename',
      `${store.getters?.getUser?.username}_custom-widgets`
    );
    formData.append('tabletype', 'custom-widgets');
    formData.append('type', 'custom-widgets');
    formData.append('database_type', 'DynamoDB');
    formData.append('schema', JSON.stringify(databaseSchema));
    formData.append(
      'layout',
      '{"tabs":[{"id":0, "rows":[{"id":0, "cols":[{"id":0}]}]}]}'
    );

    await createDatabaseTable(formData);
  } catch (error) {
    throw new Error(error);
  }
};
export const saveCustomWidgets = async (widgetElement) => {
  try {
    let customWidgetDatabase = getCustomWidgetDatabase();
    if (!customWidgetDatabase) {
      await createCustomWidgetDatabase();
      await store.dispatch('fetchUserDataBase');
      customWidgetDatabase = getCustomWidgetDatabase();
    }
    const {
      value: { name, description, inputs, html, ...settings },
      type,
    } = widgetElement;

    const payload = {
      item: {
        name,
        description,
        inputs,
        html,
        settings,
        type,
      },
    };
    await addDatabaseItem(customWidgetDatabase?.name, payload);
  } catch (error) {
    throw new Error(error);
  }
};

export const stuctureResponseToPageElements = (widgetData = []) => {
  return widgetData.map((item) => {
    const { id, created, updated, owner, type, settings, ...value } = item;

    return {
      value: { ...value, ...settings },
      type,
    };
  });
};

export const getCustomWidgetDatabase = () => {
  return store.getters.getDatabaseList?.find(
    (database) => database.type === 'custom-widgets'
  );
};
export const getCustomWidgets = async () => {
  try {
    const database = getCustomWidgetDatabase();

    if (database) {
      const response = await getCustomDatabaseItems(database.name, '', true);

      const data = response.data.items;
      const widgets = stuctureResponseToPageElements(data);
      return widgets;
    }
    return [];
  } catch (error) {
    return [];
  }
};
export const pageChartTypeMapping = [
  { type: 'highchart', key: 'highchart' },
  { type: 'dataframe', key: 'dataframe' },
  { type: 'timeseries', key: 'timeSeries' },
];
export const pageChartTypes = pageChartTypeMapping.map(
  (chartMap) => chartMap.type
);
export const getPagePropChartKey = (chartType) => {
  return pageChartTypeMapping.find((chartMap) => chartMap.type == chartType)
    .key;
};
